import axios from "axios";
import React, { useEffect, useMemo, useState } from "react";
import { MDBCol, MDBIcon } from "mdbreact";
import { Label, Input, Alert } from "reactstrap";
import { useForm } from "react-hook-form";
import {
  Button,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  Table,
} from "reactstrap";
import { postMethod } from "../../../../_services/_postMethod";
import { API_BASE_URL } from "../../../../_services/constant";

export default function Whatsapp(props) {
  const { custInfo } = props;
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const companyName = localStorage.getItem("jwl_brand_name");

  // unique mobile array
  const uniqueMobilesArray = custInfo.reduce((accumulator, currentObject) => {
    const mobileExists = accumulator.some(
      (obj) => obj.mobile === currentObject.mobile
    );
    if (!mobileExists) accumulator.push(currentObject);
    return accumulator;
  }, []);

  // --------logo-----------
  const [logo, setLogo] = useState(null);
  const handlerLogo = () => {
    postMethod("api/customervisit/get_branch_logo").then((data) => {
      setLogo(data.data[0].logo);
    });
  };
  useEffect(() => {
    handlerLogo();
  }, []);

  // --------------------forTextarea----------------------------------------------
  const [extraMsg, setExtraMsg] = useState({ contact_us: "", extra_text: "" });
  const [text, setText] = useState("");
  const maxLength = 250;
  const maxLength1 = 200;

  const handleChange = (e) => {
    const newText = e.target.value;
    if (newText.length <= maxLength) setText(newText);
  };

  const handleChange1 = (e) => {
    const newText1 = e.target.value;
    if (newText1.length <= maxLength1) {
      setExtraMsg({ ...extraMsg, extra_text: newText1 });
    }
  };

  // ----------------------forImage----------------------------------------------
  const [selectedImage, setSelectedImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedImage(file);
      const previewURL = URL.createObjectURL(file);
      setImagePreview(previewURL);
    }
  };

  // ---------------------- Pagination + Search ----------------------
  const [searchTerm, setSearchTerm] = useState("");

  const filteredData = uniqueMobilesArray.filter((item) =>
    Object.values(item).some(
      (value) =>
        typeof value === "string" &&
        value.toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  const recordsPerPage = 200;
  const [currentPage, setCurrentPage] = useState(1);
  const lastIndex = currentPage * recordsPerPage;
  const firstIndex = lastIndex - recordsPerPage;
  const records = filteredData.slice(firstIndex, lastIndex);
  const npage = Math.ceil(filteredData.length / recordsPerPage);
  const numbers = [...Array(npage + 1).keys()].slice(1);

  function prevPage() {
    if (currentPage !== 1) {
      setCurrentPage(currentPage - 1);
      setSelectAll(false);
    }
  }
  function nextPage() {
    if (currentPage !== npage) {
      setCurrentPage(currentPage + 1);
      setSelectAll(false);
    }
  }
  function changeCPage(id) {
    setCurrentPage(id);
    setSelectAll(false);
  }

  // ---------------------- Select All (per page only) ----------------------
  const [selectAll, setSelectAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);

  const toggleSelectAll = () => {
    if (selectAll) {
      setSelectedRows(
        selectedRows.filter((id) => !records.some((row) => row.mobile === id))
      );
    } else {
      const currentPageMobiles = records.map((row) => row.mobile);
      setSelectedRows([...new Set([...selectedRows, ...currentPageMobiles])]);
    }
    setSelectAll(!selectAll);
  };

  const toggleRow = (rowId) => {
    if (selectedRows.includes(rowId)) {
      setSelectedRows(selectedRows.filter((id) => id !== rowId));
    } else {
      setSelectedRows([...selectedRows, rowId]);
    }
  };

  // ---------------------- Save Message ----------------------
  const saveWhatsappMessage = async () => {
    const formData = new FormData();
    formData.append("file", selectedImage);
    formData.append("mobiles", selectedRows);
    formData.append("message", text);
    formData.append("contact_us", extraMsg.contact_us);
    formData.append("extra_text", extraMsg.extra_text);
    formData.append("bb_id", localStorage.getItem("jwl_branch_id"));

    try {
      await axios.post(
        API_BASE_URL + "api/customervisit/whatsapp/bulk/message",
        formData,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
            "auth-token": localStorage.getItem("jwl_token"),
          },
        }
      );
    } catch (error) {
      console.error("Error uploading images:", error);
    }
  };

  function onUpload() {
    if (selectedRows.length > 0) {
      saveWhatsappMessage();
      setSelectAll(false);
      toggle();
      setSelectedImage(null);
      setImagePreview(null);
      setSelectedRows([]);
      setText("");
      alert("send");
    } else {
      alert("please choose mobile number.");
    }
  }

  // ---------------------- Render ----------------------
  return (
    <>
   <Button color="primary" onClick={toggle}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 48 48"
          width="28px"
          height="28px"
        >
          <path
            fill="#fff"
            d="M4.868,43.303l2.694-9.835C5.9,30.59,5.026,27.324,5.027,23.979C5.032,13.514,13.548,5,24.014,5c5.079,0.002,9.845,1.979,13.43,5.566c3.584,3.588,5.558,8.356,5.556,13.428c-0.004,10.465-8.522,18.98-18.986,18.98c-0.001,0,0,0,0,0h-0.008c-3.177-0.001-6.3-0.798-9.073-2.311L4.868,43.303z"
          />
          <path
            fill="#fff"
            d="M4.868,43.803c-0.132,0-0.26-0.052-0.355-0.148c-0.125-0.127-0.174-0.312-0.127-0.483l2.639-9.636c-1.636-2.906-2.499-6.206-2.497-9.556C4.532,13.238,13.273,4.5,24.014,4.5c5.21,0.002,10.105,2.031,13.784,5.713c3.679,3.683,5.704,8.577,5.702,13.781c-0.004,10.741-8.746,19.48-19.486,19.48c-3.189-0.001-6.344-0.788-9.144-2.277l-9.875,2.589C4.953,43.798,4.911,43.803,4.868,43.803z"
          />
          <path
            fill="#cfd8dc"
            d="M24.014,5c5.079,0.002,9.845,1.979,13.43,5.566c3.584,3.588,5.558,8.356,5.556,13.428c-0.004,10.465-8.522,18.98-18.986,18.98h-0.008c-3.177-0.001-6.3-0.798-9.073-2.311L4.868,43.303l2.694-9.835C5.9,30.59,5.026,27.324,5.027,23.979C5.032,13.514,13.548,5,24.014,5 M24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974 M24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974 M24.014,4C24.014,4,24.014,4,24.014,4C12.998,4,4.032,12.962,4.027,23.979c-0.001,3.367,0.849,6.685,2.461,9.622l-2.585,9.439c-0.094,0.345,0.002,0.713,0.254,0.967c0.19,0.192,0.447,0.297,0.711,0.297c0.085,0,0.17-0.011,0.254-0.033l9.687-2.54c2.828,1.468,5.998,2.243,9.197,2.244c11.024,0,19.99-8.963,19.995-19.98c0.002-5.339-2.075-10.359-5.848-14.135C34.378,6.083,29.357,4.002,24.014,4L24.014,4z"
          />
          <path
            fill="#40c351"
            d="M35.176,12.832c-2.98-2.982-6.941-4.625-11.157-4.626c-8.704,0-15.783,7.076-15.787,15.774c-0.001,2.981,0.833,5.883,2.413,8.396l0.376,0.597l-1.595,5.821l5.973-1.566l0.577,0.342c2.422,1.438,5.2,2.198,8.032,2.199h0.006c8.698,0,15.777-7.077,15.78-15.776C39.795,19.778,38.156,15.814,35.176,12.832z"
          />
          <path
            fill="#fff"
            fill-rule="evenodd"
            d="M19.268,16.045c-0.355-0.79-0.729-0.806-1.068-0.82c-0.277-0.012-0.593-0.011-0.909-0.011c-0.316,0-0.83,0.119-1.265,0.594c-0.435,0.475-1.661,1.622-1.661,3.956c0,2.334,1.7,4.59,1.937,4.906c0.237,0.316,3.282,5.259,8.104,7.161c4.007,1.58,4.823,1.266,5.693,1.187c0.87-0.079,2.807-1.147,3.202-2.255c0.395-1.108,0.395-2.057,0.277-2.255c-0.119-0.198-0.435-0.316-0.909-0.554s-2.807-1.385-3.242-1.543c-0.435-0.158-0.751-0.237-1.068,0.238c-0.316,0.474-1.225,1.543-1.502,1.859c-0.277,0.317-0.554,0.357-1.028,0.119c-0.474-0.238-2.002-0.738-3.815-2.354c-1.41-1.257-2.362-2.81-2.639-3.285c-0.277-0.474-0.03-0.731,0.208-0.968c0.213-0.213,0.474-0.554,0.712-0.831c0.237-0.277,0.316-0.475,0.474-0.791c0.158-0.317,0.079-0.594-0.04-0.831C20.612,19.329,19.69,16.983,19.268,16.045z"
            clip-rule="evenodd"
          />
        </svg>
      </Button>

      <Modal isOpen={modal} size="lg" backdrop="static" zIndex="9999999" centered>
        <ModalHeader>
          <Row className="w-100">
            <Col sm="6">Whats-App Messenger</Col>
            <Col sm="6">
              <i
                className="fa fa-close pull-right pointerShow"
                onClick={toggle}
              ></i>
            </Col>
          </Row>
        </ModalHeader>

        <ModalBody className="table-responsive" style={{ maxHeight: "650px" }}>
          <Row>
            {/* Search and Recipient Table */}
            <Col md="6">
              <div className="form-inline mb-3 position-relative">
                <MDBIcon
                  icon="search"
                  className="position-absolute text-muted"
                  style={{
                    left: "12px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    pointerEvents: "none",
                    zIndex: 1,
                  }}
                />
                <input
                  className="form-control form-control-sm w-100 pl-5"
                  type="text"
                  placeholder="Search..."
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                    setCurrentPage(1);
                  }}
                />
              </div>

              <div
                className="border rounded"
                style={{ maxHeight: "450px", overflowY: "auto" }}
              >
                <Table dark striped hover responsive>
                  <thead>
                    <tr>
                      <th>
                        <button
                          className="btn btn-sm btn-light"
                          onClick={toggleSelectAll}
                        >
                          {selectAll ? "None" : "All"}
                        </button>
                      </th>
                      <th>Name</th>
                      <th>Mobile</th>
                      <th>Category</th>
                    </tr>
                  </thead>
                  <tbody>
                    {records.map((item, i) => (
                      <tr key={i}>
                        <td>
                          <input
                            type="checkbox"
                            checked={selectedRows.includes(item.mobile)}
                            onChange={() => toggleRow(item.mobile)}
                          />
                        </td>
                        <td>{item.full_name || item.customer_name}</td>
                        <td>{item.mobile}</td>
                        <td>
                          {item.category_name || item.customer_category}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </Col>

            {/* Message Composer */}
            <Col md="6">
              <div className="p-2 border rounded">
                <h6>Message</h6>
                <span>
                  {" "}
                  Dear CUSTOMER NAME, This is to inform {" "}
                </span>
                <div className="form-group">
                  <textarea
                    className="form-control"
                    rows={2}
                    placeholder="Typing..."
                    value={text}
                    onChange={handleChange}
                  />
                  <div className="text-right text-danger">
                    {maxLength - text.length}/{maxLength}
                  </div>
                </div>

                 <div className="form-group">
                  <textarea
                    className="form-control"
                    rows={2}
                    placeholder="Additional Message"
                    value={extraMsg.extra_text}
                    onChange={handleChange1}
                  />
                  <div className="text-right text-danger">
                    {maxLength1 - extraMsg.extra_text.length}/{maxLength1}
                  </div>
                </div>
                
                  <div className="form-group">
                    <span className="mr-2">For assistance, please contact</span>
  <textarea
                    className="form-control"
                    rows={2}
                    placeholder="Phone / Name"
                    value={extraMsg.contact_us}
                    onChange={(e) =>
                      setExtraMsg({ ...extraMsg, contact_us: e.target.value })
                    }
                  />
                  <span>.</span>
                
                
                </div>

               
                <div className="form-group">
                  <label>Upload Image (Optional)</label>
                  <div className="d-flex">
                    <input
                      type="file"
                      className="form-control-file"
                      onChange={handleImageChange}
                    />
                    <img
                      src={
                        selectedImage
                          ? imagePreview
                          : API_BASE_URL + "BranchLogo/" + logo
                      }
                      alt="Preview"
                      style={{
                        width: "100px",
                        height: "100px",
                        objectFit: "contain",
                        marginLeft: "1rem",
                        borderRadius: "4px",
                      }}
                    />
                  </div>
                </div>

                <div className="text-right">
                  <Button color="primary" onClick={onUpload}>
                    Send Message
                  </Button>
                </div>
              </div>
            </Col>
          </Row>

          {/* Pagination */}
          <Row className="mt-3">
            <Col className="text-center">
              <nav>
                <ul className="pagination justify-content-center">
                  <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                    <button className="page-link" onClick={prevPage}>
                      Prev
                    </button>
                  </li>

                  {numbers.map((n, i) => {
                    if (
                      n === 1 ||
                      n === npage ||
                      (n >= currentPage - 2 && n <= currentPage + 2)
                    ) {
                      return (
                        <li
                          className={`page-item ${
                            currentPage === n ? "active" : ""
                          }`}
                          key={i}
                        >
                          <button
                            className="page-link"
                            onClick={() => changeCPage(n)}
                          >
                            {n}
                          </button>
                        </li>
                      );
                    } else if (n === currentPage - 3 || n === currentPage + 3) {
                      return (
                        <li className="page-item disabled" key={i}>
                          <span className="page-link">...</span>
                        </li>
                      );
                    }
                    return null;
                  })}

                  <li
                    className={`page-item ${
                      currentPage === npage ? "disabled" : ""
                    }`}
                  >
                    <button className="page-link" onClick={nextPage}>
                      Next
                    </button>
                  </li>
                </ul>
              </nav>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
    </>
  );
}
